import Agent from '@/services/api/agent.js';

export default {
  namespaced: true,
  state: {
    agents: [],
    agent: {},
  },
  getters: {
    agents: state => state.agents,
    agent: state => state.agent,
  },
  mutations: {
    setAgents: (state, agents) => {
      state.agents = agents;
    },
    setAgent: (state, agent) => {
      state.agent = agent;
    },
  },
  actions: {
    loadAllAgents (state) {
      // Если агенты уже загружены
      if (state.agents && state.agents.length > 0) {
        return;
      }
      Agent.getAgents()
        .then(({ data }) => {
          state.commit('setAgents', data.agents);
        })
        .catch(e => console.error(e));
    },

    loadAgent (state, id) {
      return new Promise((resolve, reject) => {
        Agent.getAgent(id)
          .then(({ data }) => {
            state.commit('setAgent', data.agent);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },

    updateAgent (state, { id, agent }) {
      return new Promise((resolve, reject) => {
        Agent.updateAgent(id, agent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    newAgent (state, agent) {
      return new Promise((resolve, reject) => {
        Agent.newAgent(agent)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    deleteAgent (state, id) {
      return new Promise((resolve, reject) => {
        Agent.deleteAgent(id)
          .then((response) => {
            state.dispatch('loadAllAgents');
          })
          .catch(e => reject(e));
      });
    },

    newAgentPassword (state, { id, password, passwordConfirmation }) {
      Agent.newAgentPassword(id, password, passwordConfirmation)
        .then((response) => {
          // state.commit('updateAgents', response);
        })
        .catch(e => console.error(e));
    },
  },
};
